import * as trace from 'owa-trace';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import folderId from 'owa-service/lib/factory/folderId';
import { addCategoriesFromCalendar } from 'mini-categories/lib/api/addCategoriesFromCalendar';
import { Calendar } from 'mini-event-to-calendar-association/lib/schema/Calendar';
import { getCalendarFolderConfigurationService } from '../services/getCalendarFolderConfigurationService';
import { getFilteredUserConfiguration } from 'mini-settings/lib/selectors/getFilteredUserConfiguration';
import { getUserMailboxInfo, MailboxInfo } from 'owa-client-ids';
import { isWritableCalendar } from './processCalendarFoldersResponse';
import { updateFolderIdMapping } from '../mutators/updateFolderIdMapping';

/**
 * When we fetch the calendars using getCalendarFoldersService, some of the calendars (e.g. linked calendars)
 * have invalid folder ids. An extra service call must be made to get the right folder id and update the same.
 * The calendar folder id needs to be updated when we want to fetch events for a calendar.
 */
export async function getAndUpdateActualFolderId(calendar: Calendar) {
    let email;
    const { SessionSettings } = getFilteredUserConfiguration();
    if (
        calendar.CalendarFolderType === CalendarFolderTypeEnum.PublicCalendarFolder &&
        SessionSettings?.DefaultPublicFolderMailbox
    ) {
        email = SessionSettings.DefaultPublicFolderMailbox;
    } else {
        email = getEmailAddress(calendar.SharedOwnerEmailAddress, getUserMailboxInfo());
    }
    try {
        const response = await getCalendarFolderConfigurationService(
            calendar,
            folderId({
                Id: calendar.calculatedFolderId,
            }),
            email
        );
        const calendarFolder = response.CalendarFolder;
        calendar.isWritable = isWritableCalendar(calendarFolder, calendar.isReadOnly);
        if (calendarFolder?.EffectiveRights?.Read) {
            updateFolderIdMapping(calendar.calculatedFolderId, response.CalendarFolder.FolderId.Id);
            calendar.calculatedFolderId = response.CalendarFolder.FolderId.Id;
            calendar.isFolderIDValid = true;

            if (response.MasterList) {
                calendar.remoteCategories = response.MasterList;
                addCategoriesFromCalendar(calendar);
            }
        }
    } catch (error) {
        trace.errorThatWillCauseAlert('[getAndUpdateActualFolderId]: ' + error);
        return;
    }
}

const getEmailAddress = (ownerEmailAddress: string, mailboxInfo: MailboxInfo): string =>
    ownerEmailAddress || mailboxInfo?.mailboxSmtpAddress || null;
